import {useQuery} from "@apollo/client";
import {Fragment} from "react";
import Dialog from "./Dialog";
import FormattedButton from "../../FormattedButton";
import {useBoolState} from "@/hooks";
import {FaxLimitDocument, FaxLimitQuery, FaxLimitQueryVariables} from "@/components/fax/queries.generated";
import {MessageDescriptor} from "react-intl";
import {domainAllocationToQuotaInfo} from "@/components/EndpointCreateDialog";

type Props = {
    domainId: number;
    onSuccess: () => void;
    title: MessageDescriptor;
    successItemPath: string;
};

const CreateButton = (props: Props) => {
    const {domainId, onSuccess, title, successItemPath} = props;
    const [isOpen, setShowOn, setShowOff] = useBoolState();

    const faxLimitQuery = useQuery<FaxLimitQuery, FaxLimitQueryVariables>(FaxLimitDocument, {
        variables: {
            domainId: props.domainId,
        },
        fetchPolicy: "no-cache",
    });

    return (
        <Fragment>
            <FormattedButton onClick={setShowOn} message={title} />
            <Dialog
                title={title}
                domainId={domainId}
                successItemPath={successItemPath}
                onSuccess={() => {
                    onSuccess();
                    faxLimitQuery.refetch();
                }}
                isOpen={isOpen}
                close={setShowOff}
                quotaInfo={domainAllocationToQuotaInfo(faxLimitQuery.data?.domainAllocation.services.fax)}
            />
        </Fragment>
    );
};

export default CreateButton;
